import { Point } from 'pixi.js';
import { MonoBehavior } from '../core/monoBehavior';
import { addToLevel } from '../core/Playable2DRootContainer';
import { GameEvent } from '../events/gameEvent';
import { EventName } from '../events/eventsName';
import { Layout } from '../LayoutManager';
import gsap, { Power1 } from 'gsap';
import { CARD_MOVE_TIME } from 'constants/move';
import { Displays, DESKTOP_SIDEBAR_WIDTH, DESKTOP_UI_WIDTH, BUTTONS_BOTTOM_MARGIN_DESKTOP } from 'constants/layout';
import { CircleButton } from './circleButton';
import { Store } from 'game/store/gameStore';

export class HintButton extends MonoBehavior {
    settingsOpen = false;
    blockMove = Infinity;
    button: CircleButton;
    disable = true;
    keyEventsActive = false;

    constructor() {
        super();
        this.hintClicked = this.hintClicked.bind(this);
        this.blockButton = this.blockButton.bind(this);
        this.onOpenSettings = this.onOpenSettings.bind(this);
        this.onCloseSettings = this.onCloseSettings.bind(this);
        this.updateCounter = this.updateCounter.bind(this);
        this.button = new CircleButton('hint', true);
        GameEvent.add(EventName.BLOCK_ACTION_BUTTONS, this.blockButton);
        GameEvent.add(EventName.OPEN_SETTINGS, this.onOpenSettings);
        GameEvent.add(EventName.HIDE_SETTINGS, this.onCloseSettings);
        GameEvent.add(EventName.SET_HINT_DISABLED, () => this.setDisabled(true));
        GameEvent.add(EventName.GAME_INTRO_COMPLETED, () => this.onReady());
        GameEvent.add(EventName.ADS_GRANTED, this.updateCounter);
        GameEvent.add(EventName.HINT_SHOW, this.updateCounter);
        GameEvent.add(EventName.BLOCK_KEYBOARD, () => {
            this.keyEventsActive = false;
        });
        GameEvent.add(EventName.UNBLOCK_KEYBOARD, () => {
            this.keyEventsActive = true;
        });

        GameEvent.add(EventName.ADS_CLOSED, () => {
            this.blockButton(0);
        });
        addEventListener('keydown', this.onKeyDown.bind(this));
    }

    onKeyDown(e: KeyboardEvent) {
        if (!this.keyEventsActive) return;
        if (e.code === 'KeyH') {
            this.hintClicked();
        }
    }

    blockButton(blockTime: number) {
        this.blockMove = performance.now() + blockTime;
    }
    onReady() {
        this.setDisabled(false);
        this.blockMove = 0;
        this.updateCounter();
        
    }

    start(): void {
        addToLevel(this.button.container);
        this.button.onClick(this.hintClicked);
        this.button.container.zIndex = 10;
    }
    hintClicked() {
        if (this.blockMove > performance.now()) return;

        if (Store.hintCounter < 1) {
            this.blockButton(Infinity);
            GameEvent.emit(EventName.SHOW_ADS, { place: 'hint' });
            return;
        }
        this.hint();
    }
    hint() {
        GameEvent.emit(EventName.HINT);
    }
    updateHintCounter() {
        this.updateCounter();
    }

    setDisabled(disabled: boolean) {
        this.disable = disabled;
        this.button.setDisabled(this.disable);
    }

    resize(width: number, height: number): void {
        const display = Layout.getDisplay();
        const position = new Point();
        const padding = Layout.getButtonPadding();
        const buttonSize = Layout.getButtonSize();
        switch (display) {
            case Displays.MOBILE:
            case Displays.TABLET:
                position.set(width / 2 - buttonSize * 1.5 - padding.x * 2, height / 2 - buttonSize / 2 - padding.y);

                break;
            case Displays.DESKTOP:
                position.set(-DESKTOP_SIDEBAR_WIDTH / 2, height / 2 - buttonSize * 0.5 - BUTTONS_BOTTOM_MARGIN_DESKTOP);
                break;
        }
        this.button.container.position = position;
        this.updateCounter();
    }

    onOpenSettings() {
        const display = Layout.getDisplay();
        const buttonSize = Layout.getButtonSize();
        const padding = Layout.getButtonPadding();

        if (display === Displays.DESKTOP) {
            gsap.to(this.button.container.position, {
                x: -DESKTOP_UI_WIDTH / 2,
                ease: Power1.easeOut,
                duration: CARD_MOVE_TIME,
            });
        }
    }
    onCloseSettings() {
        const display = Layout.getDisplay();

        if (display === Displays.DESKTOP) {
            gsap.to(this.button.container.position, {
                x: -DESKTOP_SIDEBAR_WIDTH / 2,
                ease: Power1.easeOut,
                duration: CARD_MOVE_TIME,
            });
        }
    }
    updateCounter() {
        const label = Store.hintCounter > 0 ? Store.hintCounter : 'Ad';
        this.button.addLabel(label);
    }
}
